import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';
import { FlyerStatus } from '@/types/flyer';

const styles = {
  flyerCard: css`
    @media (max-width: 375px) {
      min-width: 178px;
    }
    @media (max-width: 360px) {
      min-width: 168px;
    }
    @media (max-width: 360px) {
      min-width: 158px;
    }
    min-width: 183px;
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 2px;
    img {
      width: 100%;
      border-radius: 10px;
      border: 1px solid #f5f5f5;
    }
  `,
  flyerContent: css`
    padding: 2px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  `,
  flyerTitle: css`
    width: 90%;
  `,
  favoriteIcon: css`
    color: ${colors.prussian};
  `,
  favoriteIconSelected: css`
    color: ${colors.gold};
  `,
  schoolIconContainer: css`
    position: relative;
    width: ${pxToRem(60)};
  `,
  viewedTag: css`
    position: absolute;
    right: 8px;
    top: 8px;
  `,
  schoolIcon: css`
    display: flex;
    justify-content: center;
    position: absolute;
    width: ${pxToRem(32)};
    height: ${pxToRem(20)};
    padding: 2px 8px;
    top: 8px;
    right: 8px;
    background-color: ${colors.prussian300};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 4px 8px 3px rgba(0, 0, 0, 0.15);
    border-radius: 50px;
    color: ${colors.prussian};
  `,
  weekText: css`
    font-size: ${pxToRem(14)};
    color: ${colors.prussian};
    padding-bottom: 8px;
  `,
  inactiveFlyer: css`
    opacity: 70%;
  `,
  readFlyer: css`
    opacity: 80%;
  `,
  tagContainer: ({ showTag, isGrid }) => css`
    display: flex;
    flex-direction: column;
    width: max-content;
    gap: 8px;
    ${showTag && isGrid ? 'padding-top: 6px;' : ''}
  `,
  link: css`
    text-decoration: none;
    color: ${colors.prussian};
    width: 100%;
    display: block;
    outline: none;
    border-radius: 8px;
    position: relative;

    &:focus-visible {
      box-shadow: 0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.focusOutlineColor};
    }

    &:focus {
      box-shadow: 0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.focusOutlineColor};
    }
  `,
  communityTag: css`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 183px;
  `,
  ctaButton: css`
    padding: 12px 2px 2px 2px;
  `,
  imageContainer: css`
    position: relative;
    padding: 2px;
  `,
};

export default styles;
